import { initService } from "helpers/initService";
import { Subject } from "rxjs";

export interface OdataActionTrackedEvent {
  type: string;
  params: { type: "odataAction"; key: unknown };
}

class OdataActionTrackingService {
  private readonly _odataActionTracked$ = new Subject<OdataActionTrackedEvent>();
  public readonly odataActionTracked$ = this._odataActionTracked$.asObservable();

  public trackOdataAction(type: string, key: unknown) {
    this._odataActionTracked$.next({ type, params: { type: "odataAction", key } });
  }
}

let odataActionTrackingService: Readonly<OdataActionTrackingService> | null = null;

export const getOdataActionTrackingService = () => {
  if (!odataActionTrackingService) {
    odataActionTrackingService = initService(() => new OdataActionTrackingService());
  }
  return odataActionTrackingService;
};
